<template>
    <article>
        <img :src="props.imgUrl" :class="props.size" alt="image" />
    </article>
</template>

<script lang="ts" setup>
const props = defineProps({
    imgUrl: {
        type: String,
        required: true
    },
    size: {
        type: String,
        default: 'h-4 w-4'
    }
});
</script>
